import { Instagram, MessageCircle } from "lucide-react";

export const WHATSAPP = { label: "+971 50 850 3785", href: "https://wa.me/971508503785" };
export const INSTAGRAM = [
  { code: "HR", handle: "ajsluxury.hr", href: "https://www.instagram.com/ajsluxury.hr" },
  { code: "DE", handle: "ajsluxury.de", href: "https://www.instagram.com/ajsluxury.de" },
  { code: "EN", handle: "ajsluxury.en", href: "https://www.instagram.com/ajsluxury.en" },
];

export const InstagramLinks = ({ className = "" }) => (
  <div className={`flex flex-wrap gap-2 ${className}`}>
    {INSTAGRAM.map((i) => (
      <a key={i.code} data-testid={`instagram-${i.code.toLowerCase()}`} href={i.href} target="_blank" rel="noopener noreferrer" aria-label={`Instagram @${i.handle}`}
        className="inline-flex items-center gap-2 h-9 px-3 border border-white/15 text-xs text-white/70 hover:text-white hover:border-[#c9a55c] transition-colors">
        <Instagram size={15} className="text-gold" />{i.code}
      </a>
    ))}
  </div>
);

export const WhatsAppLink = ({ testId = "whatsapp-link", className = "" }) => (
  <a data-testid={testId} href={WHATSAPP.href} target="_blank" rel="noopener noreferrer"
    className={`inline-flex items-center gap-2 text-sm text-white/70 hover:text-white transition-colors ${className}`}>
    <MessageCircle size={16} className="text-[#25D366]" />WhatsApp <span dir="ltr">{WHATSAPP.label}</span>
  </a>
);
